var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAssumptions = function SvgAssumptions(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C9.924 0 5 4.924 5 11C5 15.031 8.688 19.303 10.031 23.055C12.034 28.65 11.812 32 16 32C20.25 32 19.965 28.666 21.969 23.078C23.316 19.318 27 15 27 11C27 4.924 22.074 0 16 0ZM18.592 27.176L13.634 27.795C13.457 27.283 13.267 26.684 13.036 25.902C13.033 25.892 13.029 25.881 13.027 25.871L19.215 25.098C19.127 25.393 19.033 25.703 18.951 25.981C18.82 26.43 18.703 26.82 18.592 27.176ZM12.736 24.908C12.554 24.306 12.349 23.672 12.121 23H19.887C19.764 23.359 19.641 23.719 19.535 24.059L12.736 24.908ZM16 30C14.987 30 14.521 29.883 14.003 28.75L18.241 28.219C17.627 29.873 17.18 30 16 30ZM20.672 21H11.339C10.841 19.92 10.243 18.84 9.653 17.783C8.348 15.448 7 13.033 7 11C7 6.037 11.037 2 16 2C20.963 2 25 6.037 25 11C25 13.018 23.65 15.446 22.344 17.795C21.76 18.848 21.166 19.926 20.672 21Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5C12.691 5 10 7.691 10 11C10 11.276 10.224 11.5 10.5 11.5C10.776 11.5 11 11.276 11 11C11 8.243 13.243 6 16 6C16.276 6 16.5 5.776 16.5 5.5C16.5 5.224 16.275 5 16 5Z",
    fill: "#3D3D3D",
    fillOpacity: 0.8
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAssumptions, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/assumptions.62b4ec15.svg";
export { ForwardRef as ReactComponent };